import { render, staticRenderFns } from "./NoteComponent.vue?vue&type=template&id=6dd69460&scoped=true&"
import script from "./NoteComponent.vue?vue&type=script&lang=js&"
export * from "./NoteComponent.vue?vue&type=script&lang=js&"
import style0 from "./NoteComponent.vue?vue&type=style&index=0&id=6dd69460&lang=scss&scoped=true&"
import style1 from "./NoteComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd69460",
  null
  
)

export default component.exports